import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PartnerOnboardingIDVerificationRole } from 'vopay';

/**
 * The raw ID verification `Roles` values stay the logic keys; only the rendered labels are localized. Wording per
 * Figma (`1612:6038`): "Signing Authority", "Key Controller", "Owner".
 */
export default function useIDVerificationRoleLabels() {
  const { t } = useTranslation('translations', { keyPrefix: 'OnboardingTracker.IDVerificationRoles' });

  return useMemo(() => {
    const labelsByRole: Record<PartnerOnboardingIDVerificationRole, string> = {
      SigningAuthority: t('signingAuthority', { defaultValue: 'Signing Authority' }),
      KeyController: t('keyController', { defaultValue: 'Key Controller' }),
      Owner: t('owner', { defaultValue: 'Owner' }),
    };

    return {
      /** Falls back to the raw value if the backend sends a role the union doesn't know yet. */
      resolveIDVerificationRoleLabel: (role: PartnerOnboardingIDVerificationRole): string => labelsByRole[role] ?? role,
    };
  }, [t]);
}
